var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _vm.items.length
    ? _c(
        "section",
        {
          staticClass: "analyses-popular-section d-flex flex-column ga-6",
          attrs: { "data-qa": "analyses_popular_section" },
        },
        [
          _c("h2", { staticClass: "text-h6 text--text mb-0" }, [
            _vm._v("\n    Популярные анализы\n  "),
          ]),
          _vm._v(" "),
          _c(_setup.CoreSwiper, {
            class: { "analyses-popular-section__slider": !_setup.isMobile },
            attrs: {
              "slides-per-view": _setup.isMobile ? 1.2 : "auto",
              "has-navigation": !_setup.isMobile,
              "has-pagination": _setup.isMobile,
              "space-between": 16,
              "equal-slides-height": "",
            },
            scopedSlots: _vm._u(
              [
                {
                  key: "slides",
                  fn: function ({ slideAttrs }) {
                    return _vm._l(_vm.items, function (item) {
                      return _c(
                        "div",
                        _vm._b({ key: item.id }, "div", slideAttrs, false),
                        [
                          _c(_setup.AnalysesPopularCard, {
                            staticClass: "analyses-popular-section__card",
                            attrs: {
                              "is-mobile": _setup.isMobile,
                              name: item.name,
                              href: item.href,
                              price: item.price,
                              "old-price": item.oldPrice,
                              duration: item.duration,
                              biomaterial: item.biomaterial,
                            },
                          }),
                        ],
                        1
                      )
                    })
                  },
                },
              ],
              null,
              false,
              1882638320
            ),
          }),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }